import {IApiKey} from '@verdocs/js-sdk';
import React, {FC} from 'react';
import {observer} from 'mobx-react-lite';
import {Button, CopyField} from '../Components';
import {Dialog} from './Dialog';

interface CreatedApiKeyDialogProps {
  onClose: () => void;
  apikey: IApiKey;
  /** True when this came from rotating an existing key rather than creating a new one. */
  rotated?: boolean;
}

export const CreatedApiKeyDialog: FC<CreatedApiKeyDialogProps> = observer(({onClose, apikey, rotated = false}) => {
  const owner = [apikey.profile?.first_name, apikey.profile?.last_name].filter(Boolean).join(' ');

  return (
    <Dialog onCancel={onClose}>
      <div className="overflow-y-auto">
        <div className="mb-4 text-lg font-medium text-[#33364b]">{rotated ? `New secret for ${apikey.name}` : `${apikey.name} is ready`}</div>

        <div className="mb-4 rounded-md border border-[#f0d9b5] bg-[#fdf8ef] p-3 text-[12px] leading-snug text-[#95591a]">
          {rotated
            ? 'The previous secret stopped working the moment this one was created. Anything still using it will get 401s until you update it.'
            : 'Reminder: API keys are for server-to-server calls, and should never be used by a front-end (Web or mobile) app.'}
        </div>

        <div className="mb-4">
          <div className="mb-1 text-[13px] font-medium text-[#33364b]">Access</div>
          {apikey.global_admin ? (
            <span className="rounded-full bg-[#fdf1e3] px-2 py-0.5 text-[11px] font-medium text-[#95591a]">Global Admin</span>
          ) : (
            <span className="rounded-full bg-[#efedfb] px-2 py-0.5 text-[11px] font-medium text-[#654dcb]">
              {owner ? `Personal: ${owner}` : 'Personal'}
            </span>
          )}
        </div>

        <CopyField label="Client ID" value={apikey.client_id} />
        <CopyField
          label="Client secret"
          value={apikey.client_secret || ''}
          hint="Copy it now. It is not stored and this is the only time it will be displayed."
        />

        <div className="mt-6 flex justify-end">
          <Button size="small" label="Done" onClick={onClose} />
        </div>
      </div>
    </Dialog>
  );
});
